import React from "react";
import { SHr, SLoad, SNavigation, SPage, SPopup, SText, STheme, SThread, SView } from "servisofts-component2";
import MDL from "../../MDL";
import Container from "../../Components/Container";
import Input from "../../Components/Input";
import HTTP from "../../HTTP";
import Config from "../../Config";
import MSession from "../../Assets/svg/mSession.svg"
import Carga_truck from '../../Assets/carga_truck.svg';
import Truck from '../../Assets/truck.svg';
import Coche from '../../Assets/_coche.svg';
import Furgoneta from '../../Assets/_furgoneta.svg';
import Moto from '../../Assets/_moto.svg';

const ADMIN_ROOT_TAG_STYLE = "color:#22c55e;font-weight:700";
const ADMIN_ROOT_MSG_STYLE = "color:#38bdf8;font-weight:600";

const logAdminRoot = (message, data) => {
    if (typeof data === "undefined") {
        console.log("%c[admin/root]%c " + message, ADMIN_ROOT_TAG_STYLE, ADMIN_ROOT_MSG_STYLE);
        return;
    }
    console.log("%c[admin/root]%c " + message, ADMIN_ROOT_TAG_STYLE, ADMIN_ROOT_MSG_STYLE, data);
};

export default class index extends React.Component {
    state = { user: null, matriculas: null, loading: false, error: null, }
    // TODO: RICKY TIENE QUE VERLO
    componentDidMount() {
        logAdminRoot("componentDidMount:start");
        logAdminRoot("session snapshot", {
            hasSession: !!MDL.usuario?.session,
            type: MDL.usuario?.session?.type,
            user: MDL.usuario?.session?.name,
        });
        if (!MDL.usuario?.session) {
            console.log("%c[admin/root]%c redirecting to /login (missing session)", ADMIN_ROOT_TAG_STYLE, "color:#ef4444;font-weight:700");
            SNavigation.replace("/login");
            return;
        }
        if (MDL.usuario.session.type != "admin") {
            console.log("%c[admin/root]%c redirecting to / (not admin)", ADMIN_ROOT_TAG_STYLE, "color:#ef4444;font-weight:700", MDL.usuario.session);
            SNavigation.replace("/");
            return;
        }
        logAdminRoot("session accepted, setting user", MDL.usuario.session);
        this.setState({ user: MDL.usuario.session });
    }
    async findMatricula(_mat) {
        let mat = (_mat ?? "").trim();
        if (!mat) {
            this.setState({ matriculas: null, loading: false, error: null });
            return;
        }
        this.setState({ loading: true, error: null });
        try {
            const resp = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/buscador_matricula?matricula=" + mat });
            if (!Array.isArray(resp)) {
                this.setState({ matriculas: null, loading: false, error: resp?.message ?? "Error al buscar la matrícula." });
                return;
            }
            this.setState({ matriculas: resp, loading: false });
        } catch (e) {
            this.setState({ matriculas: null, loading: false, error: e?.message ?? "No se pudo conectar con el servidor." });
        }
    }
    createChecklist = async (matricula) => {
        SPopup.open({
            key: "creating",
            content: <SView col={"xs-12"} center padding={24} backgroundColor={STheme.color.background}>
                <SLoad />
                <SText style={{ marginTop: 12, opacity: 0.6 }}>Creando checklist...</SText>
            </SView>
        });
        try {
            const resp = await MDL.checklist.crearChecklist({ matricula: matricula.sMatricula, dni: "", key_usuario: MDL.usuario.session?.key, tipo_vehiculo_id: matricula.tipo_vehiculo_id, });
            SPopup.close("creating");
            if (!resp || !resp.id) {
                SPopup.open({
                    key: "error",
                    content: <SView col={"xs-12"} center padding={24} backgroundColor={STheme.color.background}>
                        <SText bold fontSize={16} style={{ color: STheme.color.danger }}>Error</SText>
                        <SText style={{ marginTop: 8, textAlign: "center", opacity: 0.7 }}>{resp?.message ?? "No se pudo crear el checklist. Intente nuevamente."}</SText>
                        <SView card padding={12} style={{ marginTop: 16 }} onPress={() => SPopup.close("error")}><SText bold>Cerrar</SText></SView>
                    </SView>
                });
                return;
            }
            SNavigation.navigate('/checklist/question', { id: resp.id });
        } catch (e) {
            SPopup.close("creating");
            SPopup.open({
                key: "error",
                content: <SView col={"xs-12"} center padding={24} backgroundColor={STheme.color.background}>
                    <SText bold fontSize={16} style={{ color: STheme.color.danger }}>Error</SText>
                    <SText style={{ marginTop: 8, textAlign: "center", opacity: 0.7 }}>{e?.message ?? "Ocurrió un error inesperado."}</SText>
                    <SView card padding={12} style={{ marginTop: 16 }} onPress={() => SPopup.close("error")}><SText bold>Cerrar</SText></SView>
                </SView>
            });
        }
    }
    selectMatricula(item) {
        SPopup.open({
            key: "confirm", content: <SView col={"xs-12"} center padding={16} backgroundColor={STheme.color.background}
                style={{
                    borderRadius: 16, borderWidth: 1, borderColor: "rgba(255,255,255,0.05)", shadowColor: "#000", shadowOpacity: 0.35, shadowRadius: 18
                }}>
                <SText fontSize={16} bold>Realizar Checklist</SText>
                <SText style={{ marginTop: 8, fontSize: 18, }}>{item.sMatricula}</SText>
                <SView row style={{ marginTop: 16 }}>
                    <SView card backgroundColor={STheme.color.danger} padding={12} style={{ marginLeft: 8 }}
                        onPress={() => {
                            SPopup.close("confirm");
                        }}>
                        <SText color={STheme.color.text} bold>Cancelar</SText>
                    </SView>
                    <SView width={16} />
                    <SView card backgroundColor={STheme.color.primary} style={{ borderWidth: 1, borderColor: STheme.color.secondary }} padding={12}
                        onPress={() => {
                            SPopup.close("confirm");
                            this.createChecklist(item);
                        }}>
                        <SText color={STheme.color.text} bold>Continuar</SText>
                    </SView>
                </SView>
            </SView>
        })
    }
    render() {
        const { matriculas, loading, user, error } = this.state;
        const renderIcon = (item) => {


            const status = String(item?.status ?? item?.estado ?? '').trim().toLowerCase() || 'none';
            const iconFill = status === 'none' ? "#c5c3c3" : STheme.color.secondary;

            if (item?.tipo_vehiculo_id === 1) {
                return <Truck width={69} height={70} fill={iconFill} />;
            }

            switch (String(item?.sTipo ?? '').trim().toUpperCase()) {
                case 'COCHE':
                    return <Coche width={79} height={70} fill={iconFill} />;
                case 'FURGONETA':
                case 'FURGON':
                case 'FRIGO FURGON':
                    return <Furgoneta width={64} height={70} fill={iconFill} />;
                case 'LONA AUTOMOCIÓN':
                    return <Carga_truck width={99} height={70} fill={iconFill} />;
                case 'RIGIDOS':
                    return <Truck width={69} height={70} fill={iconFill} />;
                case 'MOTO':
                    return <Moto width={64} height={65} fill={iconFill} />;
                case 'TRACTORA':
                    return <Truck width={69} height={70} fill={iconFill} />;
                default:
                    return <Carga_truck width={69} height={70} fill={iconFill} />;
            }
        };
        return <SPage title={""} preventBack backgroundColor={STheme.color.background} hidden header={<SView col={"xs-12"} height={60} style={{ paddingHorizontal: 20, justifyContent: "center" }}>
            <SView row style={{ justifyContent: "space-between", alignItems: "center" }}>
                <SView row border={"transparent"} center>
                    <SText bold fontSize={22} color={STheme.color.text}>Gestión</SText>
                    <SText bold fontSize={22} color={STheme.color.secondary}>Flotas</SText>
                </SView>
                <SView onPress={() => {
                    MDL.usuario.logout();
                    SNavigation.replace("/login");
                }}>
                    <SView row border={"transparent"} center>
                        <MSession fill={STheme.color.danger + '85'} width={20} height={20} />
                        <SText bold style={{ color: STheme.color.danger + '85', fontSize: 20, paddingLeft: 4 }}>Cerrar sesión</SText>
                    </SView>
                </SView>
            </SView>
        </SView>
        }>
            <SView flex backgroundColor={"#001b44"}>
                <Container>
                    <SView style={{ paddingTop: 12, }}>
                        <SView style={{ backgroundColor: STheme.color.background, borderRadius: 24, padding: 24, borderWidth: 1, borderColor: "rgba(255,255,255,0.05)", shadowColor: "#000", shadowOpacity: 0.35, shadowRadius: 18, shadowOffset: { width: 0, height: 10 } }}>
                            <SText fontSize={32} bold color={STheme.color.text}>Bienvenido, {user?.name ?? "Chaval"}</SText>
                            <SText style={{ marginTop: 8, color: STheme.color.text + '77', fontSize: 15 }}>Administra y monitorea tu flota de vehículos.</SText>
                            <SView style={{ marginTop: 24 }} height={80} border={"transparent"}>
                                <SText bold style={{ marginBottom: 8, fontSize: 13, letterSpacing: 1, color: STheme.color.text }}>BUSCAR MATRÍCULA</SText>
                                <Input ref={ref => this.input = ref} style={{ width: "100%", backgroundColor: STheme.color.card, color: STheme.color.text, borderRadius: 16, borderWidth: 2, borderColor: "transparent", paddingVertical: 0 }}
                                    placeholder="Ej: R-0029-BBF"
                                    placeholderTextColor={STheme.color.lightGray}
                                    onChangeText={e => {
                                        new SThread(300, "t", true).start(() => {
                                            this.findMatricula(e);
                                        });
                                    }}
                                />
                            </SView>
                        </SView>
                    </SView>
                    {loading && (
                        <SView col={"xs-12"} style={{ alignItems: "center", paddingVertical: 20 }}>
                            <SLoad />
                        </SView>
                    )}
                    {!loading && error && (
                        <SView col={"xs-12"} center style={{ alignItems: "center", paddingVertical: 14, borderRadius: 18, backgroundColor: STheme.color.danger + '12', marginTop: 18, padding: 16, borderWidth: 1, borderColor: "rgba(255,93,93,0.18)" }}>
                            <SText bold style={{ color: STheme.color.danger }}>Error</SText>
                            <SText style={{ color: STheme.color.danger + '77', opacity: 0.9, textAlign: "center", fontSize: 13 }}>{error}</SText>
                        </SView>
                    )}
                    {!loading && !error && matriculas && (matriculas ?? []).length === 0 && (
                        <SView col={"xs-12"} style={{ alignItems: "center", marginTop: 32 }}>
                            <SText style={{ color: STheme.color.text + '77' }}>Sin resultados</SText>
                        </SView>
                    )}
                    {!loading && !error && matriculas && (matriculas ?? []).length > 0 && (
                        <SView col={"xs-12"} style={{ marginTop: 24 }}>
                            {matriculas.map((item, index) => (
                                <SView key={`${item.id ?? item.sMatricula ?? item.tipo_vehiculo_id ?? "mat"}-${index}`} card onPress={() => this.selectMatricula(item)} style={{ marginBottom: 12, borderRadius: 16, padding: 14, flexDirection: "row", alignItems: "center", backgroundColor: "#122c5b", borderWidth: 1, borderColor: STheme.color.secondary + "44", }}>
                                    <SView style={{ width: 80, height: 80, borderRadius: 14, alignItems: "center", justifyContent: "center", backgroundColor: STheme.color.secondary + "11", borderWidth: 1, borderColor: STheme.color.secondary + "55", marginRight: 14, }}>
                                        {renderIcon(item)}
                                    </SView>
                                    <SView style={{ flex: 1 }}>
                                        <SText bold style={{ fontSize: 18, color: STheme.color.text, letterSpacing: 0.5 }} numberOfLines={1}>{item.sMatricula}</SText>
                                        <SView style={{ flexDirection: "row", flexWrap: "wrap", marginTop: 4 }}>
                                            <SView style={{ backgroundColor: STheme.color.secondary + "33", borderRadius: 6, paddingHorizontal: 7, paddingVertical: 2, marginRight: 6, marginTop: 2 }}>
                                                <SText style={{ color: STheme.color.secondary, fontSize: 11, fontWeight: "bold" }}>{item.sTipo ?? "S/T"}</SText>
                                            </SView>
                                            <SView style={{ backgroundColor: "rgba(255,255,255,0.08)", borderRadius: 6, paddingHorizontal: 7, paddingVertical: 2, marginTop: 2 }}>
                                                <SText style={{ color: "#a9bdd9", fontSize: 11 }}>ID {item.tipo_vehiculo_id ?? "—"}</SText>
                                            </SView>
                                        </SView>
                                        <SText style={{ color: "#7a94b4", fontSize: 12, marginTop: 5 }} numberOfLines={1}>{item.sModelo ? item.sModelo : "Modelo no especificado"}</SText>
                                    </SView>
                                    <SView center style={{ width: 30, height: 30, borderRadius: 99, backgroundColor: STheme.color.secondary + "33", alignItems: "center", justifyContent: "center", marginLeft: 10 }}>
                                        <SText bold style={{ color: STheme.color.secondary, fontSize: 16 }}>›</SText>
                                    </SView>
                                </SView>
                            ))}
                            <SHr h={200} />
                        </SView>
                    )}
                    <SHr h={40} />
                </Container>
            </SView>
        </SPage>
    }
}